<template>
  <div v-if="targetUrl && !dismissed" class="new-cabinet-banner">
    <feather-icon icon="ArrowUpCircleIcon" size="16" class="new-cabinet-banner__icon" />
    <span class="new-cabinet-banner__text">
      Готовится новый кабинет {{ appName }} — часть разделов уже переехала туда.
    </span>
    <a :href="targetUrl" target="_blank" rel="noopener" class="new-cabinet-banner__link">
      Открыть новый кабинет
    </a>
    <button
      type="button"
      class="new-cabinet-banner__close"
      aria-label="Скрыть полосу до конца сеанса"
      @click="dismiss"
    >
      <feather-icon icon="XIcon" size="16" />
    </button>
  </div>
</template>

<script>
// Переход на новый кабинет (распоряжение заказчика 22.09.2026): старый кабинет
// остаётся рабочим, пока новый не возьмёт весь функционал, но должен ненавязчиво
// вести на новый. Полоса рендерится в НОРМАЛЬНОМ потоке документа (внутри области
// содержимого layout'а), а не поверх/fixed — так она физически не может перекрыть
// закреплённые навигацию и боковое меню ни на одном брейкпоинте и ни в одном скине,
// что и требуется («ничего не перекрыто меню»).
//
// Адрес нового кабинета приходит не из сборочной переменной VUE_APP_*, а из
// window.__RUNTIME_CONFIG__, которую на каждый запрос страницы формирует
// server.js из переменной окружения КОНТЕЙНЕРА (NEW_CABINET_URL). Значит
// включить/выключить полосу можно пересозданием контейнера без пересборки образа.
// Пусто или не задано — targetUrl пустая строка, v-if гасит компонент целиком.
import { $themeConfig } from '@themeConfig'

const STORAGE_KEY = 'alfa-new-cabinet-banner-dismissed'

export default {
  name: 'NewCabinetBanner',
  data() {
    return {
      dismissed: false,
    }
  },
  computed: {
    appName() {
      return $themeConfig.app.appName
    },
    targetUrl() {
      const cfg = (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {}
      return (cfg.newCabinetUrl || '').trim()
    },
  },
  created() {
    try {
      // sessionStorage, не localStorage: полоса — временная мера перехода и
      // должна оставаться заметной в новых сеансах, а не пропасть навсегда
      // после одного случайного закрытия.
      this.dismissed = window.sessionStorage.getItem(STORAGE_KEY) === '1'
    } catch (e) {
      // приватный режим/запрет хранилища — просто не запоминаем закрытие
      this.dismissed = false
    }
  },
  methods: {
    dismiss() {
      this.dismissed = true
      try {
        window.sessionStorage.setItem(STORAGE_KEY, '1')
      } catch (e) {
        // не критично: полоса просто не запомнит закрытие до перезагрузки
      }
    },
  },
}
</script>

<style scoped>
.new-cabinet-banner {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.5rem 1rem;
  margin-bottom: 1rem;
  background: #fff3cd;
  color: #664d03;
  border: 1px solid #ffe69c;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  flex-wrap: wrap;
}
.new-cabinet-banner__icon {
  flex-shrink: 0;
}
.new-cabinet-banner__text {
  flex: 1 1 220px;
}
.new-cabinet-banner__link {
  font-weight: 600;
  white-space: nowrap;
  color: #664d03;
  text-decoration: underline;
}
.new-cabinet-banner__close {
  background: transparent;
  border: 0;
  line-height: 1;
  cursor: pointer;
  color: #664d03;
  padding: 0 0.25rem;
  margin-left: auto;
}
@media (max-width: 480px) {
  .new-cabinet-banner {
    font-size: 0.82rem;
  }
  .new-cabinet-banner__text {
    flex-basis: 100%;
  }
}
</style>
